export default __webpack_public_path__ + "static/media/volume-mute-fill.3101d4db.svg";